// Copyright 2024 Hewlett Packard Enterprise Development LP
import { Box } from 'grommet'
import { LinkNext } from 'grommet-icons'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { Card, Typography } from '../../../components'

const FeaturedServicesCard = ({
  service: { name, id, short_description, slug },
  category,
  t
}) => {
  const navigate = useNavigate()
  const LDFlags = useFlags()
  // if wellness LD flag is Off, should not show wellness dashboard
  const showWellness =
    !LDFlags['glcp-unified-wellness-dashboard'] && slug === 'WD'

  return (
    <>
      {!showWellness && (
        <Card
          a11yTitle={`${t('dashboard:common.view_details')} ${name}`}
          cardWidth="100%"
          onClick={(e) => {
            e.preventDefault()
            navigate(`/services/service-catalog/${id}`)
          }}
          action={<LinkNext color="green" />}
          description={t(
            `services:${slug}.short_description`,
            short_description
          )}
          title={
            <Box pad={{ bottom: 'brand' }}>
              <Typography type="heading" level={3}>
                {name}
              </Typography>
              <Typography type="text" size="xsmall">
                {t(`dashboard:common.category.${category}`)}
              </Typography>
            </Box>
          }
          testId="service-centric-featured-services-card"
        />
      )}
    </>
  )
}

FeaturedServicesCard.propTypes = {
  service: PropTypes.object.isRequired,
  category: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
}

export default FeaturedServicesCard
